// extracted by mini-css-extract-plugin
export default {"panel":"oIp4953KQF_OvBmwOGt0","formItem":"j3Stw7SjjZPZhzXQp1Qx","select":"dvoKL5mHcL86EI9nuuPN","input":"EJHoiwmSIeqCW6aP6aQL","multiselect":"IScdBLWkalaxFurL4Qu3"};